import { useContext } from 'react'
import { Data } from '@styled-icons/boxicons-solid'
import { formatEmptyValue } from '../../../../utils/common'
import Tooltip from '../../../common/tooltip'
import {
  FunctionalDiagramEditContext,
  SET_CIRCUIT_PINS,
} from './context/context'
import CheckBox from '../../../common/CheckBox'

const ComponentSearchPinsRows = (props) => {
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)

  return (
    <>
      <div className="font-semibold">
        <div className="flex flex-row w-full rounded-t-lg text-black text-sm border-b border-gray-500 py-2">
          <div className="flex w-1/12 pl-1 items-center"></div>
          <div className="flex w-3/12 pl-2 items-center">Circuit</div>
          <div className="flex w-2/12 pl-6 items-center">Pin</div>
          <div className="flex w-2/12 pl-6 items-center">Color</div>
          <div className="flex w-4/12 pl-6 items-center">Description</div>
        </div>
      </div>
      <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
        {state?.selectedSectionRecord?.data?.map((section, index) => {
          let circuitPin = state.selectedCircuitPins?.includes(
            `${section?.circuit_id}**$$${section?.pin_from}**$$${section?.connector_from}`
          )
          return (
            <div
              key={`selected-section-component-${index}`}
              className="flex flex-row flex-wrap items-center w-full py-2 border-b border-gray-500 text-black text-sm"
            >
              <div className="flex flex-row w-full">
                <div className="flex w-1/12 pl-1 items-center table_text">
                  <CheckBox
                    value={circuitPin}
                    checked={circuitPin}
                    onChange={(value) => {
                      dispatch({
                        type: SET_CIRCUIT_PINS,
                        data: `${section?.circuit_id}**$$${section?.pin_from}**$$${section?.connector_from}`,
                        startConnectors: section?.connector_from,
                      })
                    }}
                  />
                </div>
                <div className="flex w-3/12 pl-2 items-center table_text">
                  <Tooltip position={'top'} message={section?.circuit_name}>
                    <div>{formatEmptyValue(section?.circuit_name)}</div>
                  </Tooltip>
                </div>
                <div className="flex w-2/12 pl-6 items-center table_text">
                  <Tooltip position={'top'} message={section?.pin_from}>
                    <div>{formatEmptyValue(section?.pin_from)}</div>
                  </Tooltip>
                </div>

                <div className="flex w-2/12 pl-6 items-center table_text">
                  <Tooltip position={'top'} message={section?.color}>
                    <div>{formatEmptyValue(section?.color)}</div>
                  </Tooltip>
                </div>
                <div className="flex w-4/12 pl-6 items-center table_text">
                  <div>{formatEmptyValue(section?.circuit_desc)}</div>
                </div>
              </div>
            </div>
          )
        })}
        {state?.selectedSectionRecord?.data?.length == 0 && (
          <div className="flex justify-center h-100 py-6 items-center">
            No Data Found <Data size="2rem" color="gray" />
          </div>
        )}
      </div>
    </>
  )
}

export default ComponentSearchPinsRows
